<template>
  <div class="sscontainer-menu-footer cooloc"><h3>COOLOC</h3>
    <ul class="menu-footer">
      <!--li><a href="#" title="Découvrir comment ça marche">Comment ça marche</a>
      </li-->
      <li>
        <router-link
          :to="{name: 'Conduct'}"
          target="_blank"
          title="Voir note charte de bonne conduite">
          Charte de bonne conduite
        </router-link>
      </li>
      <li><a href="https://cooloc.com/blog/" target="_blank" title="Découvrir nos conseils utiles">Conseils utiles</a></li>
      <!--li><a href="#" title="Découvrir nos tarifs">Tarifs</a></li-->
      <!--li><a href="#" title="Découvrir tous les services">Tous les services</a>
      </li-->
    </ul>
  </div>
</template>

<script>
export default {
  name: 'footer-menus-cooloc',
}
</script>
